"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BanLimitCardCms = void 0;
var BanLimitCardCms = /** @class */ (function () {
    function BanLimitCardCms() {
        this.wirlessLimitLabel = 'Limit of wireless lines';
        this.removeLineLabel = 'Remove line ';
        this.installmentPlanLabel = 'monthly payments of $';
    }
    return BanLimitCardCms;
}());
exports.BanLimitCardCms = BanLimitCardCms;
//# sourceMappingURL=BanLimitCard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/CreditResponseModal/BanLimitCard/BanLimitCard.cms.js
// module id = 2013
// module chunks = 8